module.exports = __webpack_public_path__ + "img/preview-7.08e8e6e5.png";